export const normalizeCountryCode = (c) => {
  if (!c) return null;
  if (typeof c === 'string') return c;
  return c.value ?? c.label ?? null;
};

export const isUsaIncluded = (countries) => {
  const arr = Array.isArray(countries) ? countries : [];
  const codes = arr.map(normalizeCountryCode).filter(Boolean);

  if (codes.length === 0) return true;

  return codes.includes('US');
};